import TentOccupancyTable from './TentOccupancyTable';

export default TentOccupancyTable;
